import React, { FC } from "react";
import { Id, ModelFunction } from "../../../types";
import { useMachine } from "@xstate/react";
import { fetchMachine } from "../../../machines/fetch";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { activeSubscriptionIdState, modelFunctionsState } from "../../../atoms";
import { useForm } from "react-hook-form";
import {
  Button,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  Stack,
  useToast,
} from "@chakra-ui/react";
import { addModelFunction } from "../../../api/add-model-function";

type FormData = Pick<ModelFunction, "name">;

type Props = {
  onSuccess: (newModelFunctionId: Id) => void;
};

export const AddModelFunction: FC<Props> = (props) => {
  const { onSuccess } = props;

  const toast = useToast();

  const activeSubscriptionId = useRecoilValue(activeSubscriptionIdState);
  const setModelFunctions = useSetRecoilState(modelFunctionsState);

  const { register, handleSubmit, errors, watch } = useForm<FormData>();
  const watchName = watch("name");

  const onSubmit = () => {
    send(state.matches("failure") ? "RETRY" : "FETCH");
  };

  const [state, send] = useMachine(fetchMachine, {
    services: {
      fetch: () =>
        addModelFunction({
          name: watchName,
          subscriptionId: activeSubscriptionId as Id,
        }),
    },

    actions: {
      success: (_, event: any) => {
        setModelFunctions(event.data.modelFunctions);
        onSuccess(event.data.newModelFunctionId);
        toast({
          title: "modelfunctie toegevoegd",
          status: "success",
          isClosable: true,
        });
      },

      failure: (_, event: any) => {
        toast({
          title: "toevoegen van modelfunctie niet gelukt",
          description: JSON.stringify(event.data, null, 2),
          status: "error",
          isClosable: true,
        });
      },
    },
  });

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Stack spacing={8} align="start">
        <FormControl isRequired isInvalid={errors.name !== undefined}>
          <FormLabel>naam</FormLabel>
          <Input
            name="name"
            ref={register({
              required: "je hebt geen naam ingevuld",
            })}
          />
          <FormErrorMessage>{errors.name?.message}</FormErrorMessage>
        </FormControl>

        <Button type="submit" size="sm" isLoading={state.matches("loading")}>
          voeg toe
        </Button>
      </Stack>
    </form>
  );
};
